import IApplicationLanding from '@sunbit-dev/common/models/cardApply/IApplicationLanding';
import ApplicationError from '@sunbit-dev/common/models/ApplicationError';
import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import sunbitApi from '../services/sunbitApi';
import { CARD_ENV } from '../utils/helpers/envHelper';
import { TOKEN_REQUIRED_URLS } from '../constants/urls';

export enum ActionTypes {
  Init = 'ApplicationLandingActionInit',
  getLandingDetails = 'getLandingDetails',
}

const init = (applicationLanding: IApplicationLanding) => ({
  type: ActionTypes.Init,
  ...applicationLanding,
});

export const noToken = (error: ApplicationError) => ({
  type: ActionTypes.Init,
  status: ActionStatus.Failure,
  error,
});

const tokenRequired = () => {
  const urlPath = window.location.pathname;
  return TOKEN_REQUIRED_URLS.indexOf(urlPath) !== -1;
};

export const initApplication = (applicationLanding: IApplicationLanding) => {
  if (applicationLanding.token || CARD_ENV === 'ci') {
    sunbitApi
      .setInitialToken(applicationLanding.token)
      .setPendingApplicationId(applicationLanding.pendingApplicationId)
      .setApplicationId(applicationLanding.applicationId);
    return init(applicationLanding);
  } else if (tokenRequired() && (!sunbitApi.isTokenReady() || !sunbitApi.isApplicationIdReady())) {
    return noToken({ message: 'noToken', code: 'noToken' } as ApplicationError);
  }
};

export type Actions = ReturnType<typeof init>;
